import { FC } from "react";
import { SlotType } from "@/types";
import cn from "classnames";
import EventItem from "@/components/agenda/desktop/week/EventItem.tsx";

type Props = {
  className?: string;
  slot: SlotType;
};

const Slot: FC<Props> = (props) => {
  const { className, slot } = props;

  return (
    <div
      className={cn(
        `max-h-full w-full h-full grid ${slot?.rowStyle} ${slot?.columnStyle} p-[2px] `,
        className,
      )}
    >
      {slot?.childEvents?.map((r, idx) => {
        return (
          <EventItem className={r?.slotStyle} key={idx + r.id} event={r} />
        );
      })}
    </div>
  );
};

export default Slot;
